<template>
  <div class="promoteRuleBox">
    <div class="top"></div>
    <div class="content">
      <div class="main">
        <div class="topBox">
          <img src="@/assets/img/h5/logo2.png" alt="" />
        </div>
        <div class="mainBox">
          <section style="box-sizing: border-box; text-align: justify">
            <section style="font-size: 18px; box-sizing: border-box">
              <p
                style="
                  text-align: center;
                  text-wrap: wrap;
                  margin-top: 0px;
                  margin-bottom: 0px;
                  padding: 0px;
                  box-sizing: border-box;
                "
              >
                <strong style="box-sizing: border-box"
                  >爱艺术+全球合伙人计划</strong
                >
              </p>
            </section>
            <p
              style="
                text-wrap: wrap;
                margin-top: 0px;
                margin-bottom: 0px;
                padding: 0px;
                box-sizing: border-box;
              "
            >
              <br style="box-sizing: border-box" />
            </p>
            <section style="line-height: 1.8; box-sizing: border-box">
              <p
                style="
                  text-indent: 2em;
                  text-wrap: wrap;
                  margin-top: 0px;
                  margin-bottom: 0px;
                  padding: 0px;
                  box-sizing: border-box;
                "
              >
                <strong style="box-sizing: border-box">如何成为合伙人？</strong>
              </p>
            </section>
            <p
              style="
                text-indent: 2em;
                text-wrap: wrap;
                margin-top: 0px;
                margin-bottom: 0px;
                padding: 0px;
                box-sizing: border-box;
              "
            >
              有良好的会员卡充值/运营商/艺术类渠道代理运营及拓展经验，或者您在某个领域具备一定的影响力（诸如艺培机构负责人、艺术教师，自媒体博主等），均可成为我们的合伙人。
            </p>
            <p
              style="
                text-wrap: wrap;
                margin-top: 0px;
                margin-bottom: 0px;
                padding: 0px;
                box-sizing: border-box;
              "
            >
              <br style="box-sizing: border-box" />
            </p>
            <section style="line-height: 1.8; box-sizing: border-box">
              <p
                style="
                  text-indent: 2em;
                  text-wrap: wrap;
                  margin-top: 0px;
                  margin-bottom: 0px;
                  padding: 0px;
                  box-sizing: border-box;
                "
              >
                <strong style="box-sizing: border-box"
                  >成为合伙人有哪些收益?</strong
                >
              </p>
            </section>
            <section style="box-sizing: border-box">
              <p
                style="
                  text-indent: 2em;
                  text-wrap: wrap;
                  margin-top: 0px;
                  margin-bottom: 0px;
                  padding: 0px;
                  box-sizing: border-box;
                "
              >
                （1）初级合伙人---课程分销
              </p>
              <p
                style="
                  text-indent: 2em;
                  text-wrap: wrap;
                  margin-top: 0px;
                  margin-bottom: 0px;
                  padding: 0px;
                  box-sizing: border-box;
                "
              >
                用户通过您分享的推广链接成功付款，您将获得客单价25%的奖励；如果用户在购买过程中跳出链接，您将无法获得奖励；
              </p>
              <p
                style="
                  text-indent: 2em;
                  text-wrap: wrap;
                  margin-top: 0px;
                  margin-bottom: 0px;
                  padding: 0px;
                  box-sizing: border-box;
                "
              >
                （2）高级合伙人---全产品线合作
              </p>
            </section>
            <section
              style="
                text-align: center;
                margin-top: 10px;
                margin-bottom: 10px;
                line-height: 0;
                position: static;
                box-sizing: border-box;
              "
            >
              <section
                style="
                  max-width: 100%;
                  vertical-align: middle;
                  display: inline-block;
                  line-height: 0;
                  border-style: solid;
                  border-width: 1px;
                  box-sizing: border-box;
                "
              >
                <img
                  class="raw-image"
                  style="
                    vertical-align: middle;
                    max-width: 100%;
                    width: 100%;
                    box-sizing: border-box;
                  "
                  data-s="300,640"
                  crossorigin="anonymous"
                  src="https://mpicture.iartschool.com/20240805/1270033793851326464.png"
                  _src="https://mpicture.iartschool.com/20240805/1270033793851326464.png"
                />
              </section>
            </section>
            <p
              style="
                text-indent: 2em;
                text-wrap: wrap;
                margin-top: 0px;
                margin-bottom: 0px;
                padding: 0px;
                box-sizing: border-box;
              "
            >
              成为高级合伙人，您将获得爱艺术+的全域资源，包括艺术家资源，专业的拍摄剪辑团队，专业的技术团队，专业的运营团队等，我们将为您提供完善的团队作为业务的支撑。
            </p>
            <p
              style="
                text-wrap: wrap;
                margin-top: 0px;
                margin-bottom: 0px;
                padding: 0px;
                box-sizing: border-box;
              "
            >
              <br style="box-sizing: border-box" />
            </p>
            <section style="box-sizing: border-box">
              <p
                style="
                  text-indent: 2em;
                  text-wrap: wrap;
                  margin-top: 0px;
                  margin-bottom: 0px;
                  padding: 0px;
                  box-sizing: border-box;
                "
              >
                <strong style="box-sizing: border-box">期待您的加入</strong>
              </p>
  <p
                style="
                  text-indent: 2em;
                  text-wrap: wrap;
                  margin-top: 0px;
                  margin-bottom: 0px;
                  padding: 0px;
                  box-sizing: border-box;
                "
              >（1）初级合伙人注册路径：从APP端“首页—我的—推广赚钱”点击注册，等待审核通过后即可成为初级合伙人并获得推广佣金；有意向成为高级合伙人请直接联络下方工作人员。
   </p>
   <p
                style="
                  text-indent: 2em;
                  text-wrap: wrap;
                  margin-top: 0px;
                  margin-bottom: 0px;
                  padding: 0px;
                  box-sizing: border-box;
                "
             
              >（2）注册成为推广员后分享任意课程、年卡给普通用户（非推广员）可以获得分销奖励。 </p>
  <p
                style="
                  text-indent: 2em;
                  text-wrap: wrap;
                  margin-top: 0px;
                  margin-bottom: 0px;
                  padding: 0px;
                  box-sizing: border-box;
                "
              >（3）推广员存在上下级关系，下级推广员购买任意课程、年卡，其上级推广员可以获得分销奖励（注：用户A注册成为推广员后，用户A发送链接邀请用户B成为其下级推广员）。
              </p>
              <p
                style="
                  text-indent: 2em;
                  text-wrap: wrap;
                  margin-top: 0px;
                  margin-bottom: 0px;
                  padding: 0px;
                  box-sizing: border-box;
                "
              >
                联系人：客服小R（18167176677）附微信二维码
              </p>
              
            </section>
            <section
              style="
                text-align: center;
                margin-top: 10px;
                margin-bottom: 10px;
                line-height: 0;
                position: static;
                box-sizing: border-box;
              "
            >
              <section
                style="
                  max-width: 100%;
                  vertical-align: middle;
                  display: inline-block;
                  line-height: 0;
                  border-style: solid;
                  border-width: 1px;
                  box-sizing: border-box;
                "
              >
                <img
                  class="raw-image"
                  style="
                    vertical-align: middle;
                    max-width: 100%;
                    width: 100%;
                    box-sizing: border-box;
                  "
                  data-s="300,640"
                  crossorigin="anonymous"
                  src="https://mpicture.iartschool.com/20251009/1425781430658531328.png"
                  _src="https://mpicture.iartschool.com/20251009/1425781430658531328.png"
                />
              </section>
            </section>
          </section>
          <p>
            <br />
          </p>
        </div>
      </div>
      <div class="btn">
        <div class="iosPaddingBottom">
          <span @click="opation()">申请成为推广员</span>
        </div>
      </div>
    </div>
    <Toast
      :toastData="toast"
      :show="showToast"
      v-on:toastCallBack="toastCallBack"
    ></Toast>
  </div>
</template>

<script>
import Toast from "@/components/toast.vue";

export default {
  name: "promoteRule",
  metaInfo() {
    return {
      title: "推广员招募计划",
    };
  },
  data() {
    return {
      showToast: "",
      toast: {
        title: "",
        btntext: "",
        type: "",
        background: "#fff",
      },
    };
  },
  watch: {
    ["info.telephone"]() {
      this.info.telephone = this.info.telephone.replace(/\D/g, "");
    },
  },
  components: {
    Toast,
  },
  created() {
    console.log(this);
  },
  mounted() {},
  methods: {
    toastCallBack(e) {
      var type = e.type;
      var data = e.data;
      switch (type) {
        case "close":
          break;
        case "submit":
          if (data) {
            if (data.type == "examine") {
              this.$parent.getUserInfo();
            }
          }
          break;
        default:
          break;
      }
      this.showToast = false;
    },
    opation() {
      if (!this.util.loginStatus()) {
        if (
          typeof window.IARTSCHOOL != "undefined" ||
          typeof window.android != "undefined"
        ) {
          this.util.appFunction.login();
        } else {
          this.util.wechatLogin();
        }
        return;
      }
      this.showToast = true;
      this.toast = {
        type: "examine",
        title: "申请资料",
        btnText: "提交",
        background: "#FFFFFF",
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.promoteRuleBox {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  background: #ebeeed;
  .top {
    height: 375px;
    background: linear-gradient(to bottom, #d9d9e3 0%, #ebeeed 100%);
  }
  .content {
    margin-top: -375px;
    padding: 24px 16px 92px;
    .main {
      flex: 1;
      overflow: auto;
      padding: 16px 16px 0px;
      background: #ffffff;
      border-radius: 3px;
      .topBox {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        // border-bottom: 0.5px solid #e0e0e0;
        // padding-bottom: 24px;
        img {
          // width: 106px;
          width: auto;
          height: 30px;
          margin-bottom: 16px;
        }
        h5 {
          font-size: 22px;
          line-height: 32px;
          color: #333333;
        }
      }
      .common {
        margin-top: 24px;
        margin-bottom: 20px;
        .commonTop {
          p {
            font-size: 13px;
            line-height: 25px;
            color: #2d2d2d;
            font-weight: 300;
          }
        }
        .commonContent {
          li {
            font-size: 13px;
            line-height: 25px;
            color: #2d2d2d;
            font-weight: 300;
          }
        }
      }
    }
    .btn {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      background: #fff;
      padding: 14px 16px;
      box-shadow: 0px 2px 10px 2px rgba(0, 0, 0, 0.05);
      span {
        display: inline-block;
        font-size: 14px;
        line-height: 20px;
        color: #ffffff;
        border-radius: 3px;
        background: #c9373d;
        padding: 14px 0;
        text-align: center;
        width: 100%;
        font-weight: bolder;
      }
    }
  }
}
</style>
